module.exports = __webpack_public_path__ + "img/sm-web.6089705c.png";